import React, { useEffect } from "react";
import Header from "./Header";
import Main from "./Main";
import Hear from "./Hear";
import Provide from "./Provide";
import Patners from "../../../../Layout/Part/Patners";
import Join from "../../../Join";
import Footer from "../../../Footer";
import Team from "./Team";



const Company1 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {};
  }, []);
  return (
    <>
      <Header />
      <Main />
      {/* <Hear /> */}
      <Provide />
      <Patners />
      <Team />
      <Join />
      <Footer />
    </>
  );
};

export default Company1;
